import React from 'react';

const ApiKeyPermissionGroupMappingFormModal = React.lazy(() => import('../components/FormModal'));

const apiKeyPermissionGroupMappingModalRegistry = {
    core_apiKeyPermissionGroupMappingId: ApiKeyPermissionGroupMappingFormModal
};

export default apiKeyPermissionGroupMappingModalRegistry;
